<template>
  <div class="administrator-management">
    <div class="header" ref="header">
      <el-select
        v-model="roomUid"
        :placeholder="$t('upgrade_page_views_administrator_management_index_1970')"
        clearable
        filterable
        @change="getVoiceRoom"
        v-if="isAdmin"
      >
        <el-option
          :label="item.name"
          :value="item.roomUid"
          v-for="item of voiceRoomList"
          :key="item.roomUid"
        ></el-option>
      </el-select>
      <el-button
        class="add-btn"
        size="small"
        @click="addVoiceRoom()"
        v-if="!roomUid && isWhiteUser"
        >{{$t('upgrade_page_views_administrator_management_index_1971')}}</el-button
      >
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('upgrade_page_views_administrator_management_index_1972')" name="ranking">
        <rank :isWhiteUser="isWhiteUser" :uuid="createBy"></rank>
      </el-tab-pane>
      <el-tab-pane :label="$t('upgrade_page_views_administrator_management_index_1973')" name="admin">
        <div class="room-detail">
          <voice-room-detail
            :isWhiteUser="isWhiteUser"
            :isAdmin="isAdmin"
            :voiceRoomDetail="voiceRoomDetail"
            @edit-voice-room-success="getVoiceRoom()"
          ></voice-room-detail>
          <div class="role-box">
            <el-tabs v-model="roleTabName">
              <el-tab-pane :label="$t('upgrade_page_views_administrator_management_index_1974')" name="user">
                <user-list
                  :isWhiteUser="isWhiteUser"
                  :isAdmin="isAdmin"
                  :voiceRoomDetail="voiceRoomDetail"
                  @add-user-success="getVoiceRoom()"
                ></user-list>
              </el-tab-pane>
              <el-tab-pane :label="$t('upgrade_page_views_administrator_management_index_1975')" name="adminUser">
                <admin-list
                  :isWhiteUser="isWhiteUser"
                  :isAdmin="isAdmin"
                  :voiceRoomDetail="voiceRoomDetail"
                  @add-admin-success="getVoiceRoom()"
                ></admin-list>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <!-- <user-list
          :isWhiteUser="isWhiteUser"
          :isAdmin="isAdmin"
          :voiceRoomDetail="voiceRoomDetail"
          @add-admin-success="getVoiceRoom()"
          @edit-voice-room-success="getVoiceRoom()"
        ></user-list> -->
      </el-tab-pane>
    </el-tabs>
    <voice-room-form
      :voiceRoomDetail="voiceRoomFormData"
      ref="voiceRoomForm"
      @create-success="createVoiceRoomSuccess()"
    ></voice-room-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Rank from './rank.vue';
import UserList from './user-list.vue';
import AdminList from './admin-list.vue';
import VoiceRoomDetail from './voice-room-detail.vue';
import VoiceRoomForm from './voice-room-form.vue';
export default {
  name: 'AdministratorManagement',
  components: {
    Rank,
    'user-list': UserList,
    VoiceRoomForm,
    VoiceRoomDetail,
    AdminList
  },
  props: {},
  data() {
    return {
      activeName: 'ranking',
      voiceRoomList: [],
      roomUid: '',
      voiceRoomDetail: {},
      whiteList: [],
      voiceRoomFormData: {},
      roleTabName: 'user'
    };
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          if (this.isAdmin) {
            this.getAllList();
          } else {
            this.getMyList();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    isAdmin() {
      return this.uuid === '4290568' || this.uuid === '3826053';
    },
    isWhiteUser() {
      const isProduction = process.env.VUE_APP_ENV === 'production';
      if (isProduction) {
        // return [
        //   //陪玩师名单
        //   '2266452', //鹿玖
        //   // '157263'//熊兒
        //   '4292676',
        //   '4285891',
        //   '4328101',
        //   '3783920', //邹滨
        //   '3762573', // 雷敏
        //   '4310601',
        //   '4323727',
        //   '4286608',
        //   '4347257',
        //   '4329482',
        //   '4290568', //卫腾
        //   '3826053'
        // ]
        return this.whiteList.includes(this.uuid);
      } else {
        return true;
      }
    },
    createBy() {
      if (this.isAdmin) {
        return this.voiceRoomDetail.createBy;
      } else {
        return this.uuid;
      }
    }
  },
  methods: {
    async getWhiteList() {
      try {
        const { data } = await this.$http.get(
          '/player/skill/userWhite/list/32'
        );
        this.whiteList = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    getMyList() {
      this.$http.get('/voiceRoom/outside/myRoom').then(({ data }) => {
        this.voiceRoomList = data;
        const list = data.filter(item => {
          return item.createBy == this.uuid;
        });
        this.roomUid = list[0] ? list[0].roomUid : '';
        this.getVoiceRoom();
      });
    },
    getAllList() {
      this.$http
        .post('/voiceRoom/outside/list', {
          pageIndex: 0,
          pageSize: 200,
          recommend: 0
        })
        .then(({ data }) => {
          if (data) {
            this.voiceRoomList = data.content || [];
          }
        });
    },
    getVoiceRoom() {
      if (this.roomUid) {
        this.$http
          .get('/voiceRoom/admin/roomInfo', { roomUid: this.roomUid })
          .then(({ data }) => {
            if (data) {
              this.voiceRoomDetail = data || {};
            }
          })
          .catch(() => {
            this.voiceRoomDetail = {};
          });
      } else {
        this.voiceRoomDetail = {};
      }
    },
    addVoiceRoom() {
      this.voiceRoomFormData = {};
      this.$refs.voiceRoomForm.open();
    },
    createVoiceRoomSuccess() {
      location.reload();
    }
  },
  created() {
    this.getWhiteList();
  }
};
</script>
<style lang="scss" scoped>
.administrator-management {
  height: calc(100% - 66px);
  padding: 40px;
  .header {
    margin-bottom: 20px;
  }
  .room-detail {
    display: flex;
    height: 100%;
  }
  /deep/ .el-tabs {
    height: 100%;
    // .el-tabs__item.is-active {
    //   color: black;
    // }
    .el-tabs__content {
      height: calc(100% - 80px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  .role-box {
    margin-left: 40px;
    flex: 1;
  }
}
</style>
